import { Transaction } from '../../Overview/types';
import { Bot, Candle } from '../types';
import './index.css';

import PriceChart from './PriceChart';
import ProfitChart from './ProfitChart';
import { CandleSticksLatestOrder, ProfitChartApiResponse } from './types';

export interface PriceChartApiResponse {
  normal: Candle[];
  heikin: Candle[];
}

interface Props {
  bot: Bot;
  candleData: PriceChartApiResponse | undefined;
  profitData: ProfitChartApiResponse | undefined;
  selectedTimeFrameIndex: number;
  setSelectedTimeFrameIndex: React.Dispatch<React.SetStateAction<number>>;
  showCurrentOrder: boolean;
  setShowCurrentOrder: React.Dispatch<React.SetStateAction<boolean>>;
  isCandlesLoading: boolean;
  isProfitChartLoading: boolean;
  candleSticksLatestOrder?: CandleSticksLatestOrder;
  compactTransactions: Transaction[] | undefined;
}

const Charts: React.FC<Props> = (props: Props) => {
  const {
    bot,
    candleData,
    profitData,
    selectedTimeFrameIndex,
    setSelectedTimeFrameIndex,
    showCurrentOrder,
    setShowCurrentOrder,
    isCandlesLoading,
    isProfitChartLoading,
    candleSticksLatestOrder,
    compactTransactions,
  } = props;

  return (
    <div className="charts-container">
      <ProfitChart
        bot={bot}
        data={profitData}
        isLoading={isProfitChartLoading}
        showCurrentOrder={showCurrentOrder}
        setShowCurrentOrder={setShowCurrentOrder}
        compactTransactions={compactTransactions}
      />
      <PriceChart
        bot={bot}
        candles={candleData}
        selectedTimeFrameIndex={selectedTimeFrameIndex}
        setSelectedTimeFrameIndex={setSelectedTimeFrameIndex}
        isLoading={isCandlesLoading}
        candleSticksLatestOrder={candleSticksLatestOrder}
      />
    </div>
  );
};

export default Charts;
